import { useContext, useRef } from 'react'
import { emitCustomEvent, useCustomEventListener } from 'react-custom-events'
import { useFormikContext } from 'formik'
import _PaymentIQCashier from 'paymentiq-cashier-bootstrapper'
import classnames from 'classnames/bind'
import { getPaymentToken, prepareBooking } from '~/lib/api'
import { processPayment } from '~/lib/piq'
import { StoreContext } from '~/store'
import * as styles from './index.module.css'

const locations = [
  {
    "address": {
      "position": {
        "latitude": 59.338795,
        "longitude": 18.057604
      },
      "zone": 141,
      "streetName": "Tegnérgatan",
      "streetNumber": "37",
      "entrance": "",
      "city": "Stockholm"
    },
    "locationTypes": [
      "ADDRESS"
    ],
    "availableCars": 997,
    "pointOfInterest": false
  },
  {
    "address": {
      "position": {
        "latitude": 59.337048,
        "longitude": 18.05923
      },
      "zone": 119,
      "streetName": "Citykyrkan",
      "entrance": "",
      "city": "Stockholm"
    },
    "locationTypes": [
      "POINT_OF_INTEREST"
    ],
    "availableCars": 997,
    "pointOfInterest": true
  },
  {
    "address": {
      "position": {
        "latitude": 59.318966,
        "longitude": 18.070719
      },
      "zone": 172,
      "streetName": "Götgatan",
      "streetNumber": "18",
      "entrance": "",
      "city": "Stockholm"
    },
    "locationTypes": [
      "ADDRESS"
    ],
    "availableCars": 997,
    "pointOfInterest": false
  },
  {
    "address": {
      "position": {
        "latitude": 59.31483,
        "longitude": 18.07383
      },
      "zone": 172,
      "streetName": "Kvarnen Restaurang",
      "entrance": "",
      "city": "Stockholm"
    },
    "locationTypes": [
      "RESTAURANT"
    ],
    "availableCars": 997,
    "pointOfInterest": true
  },
  {
    "address": {
      "position": {
        "latitude": 59.2983,
        "longitude": 18.075573
      },
      "zone": 811,
      "streetName": "Gullmarsvägen",
      "streetNumber": "12",
      "entrance": "",
      "city": "Stockholm"
    },
    "locationTypes": [
      "ADDRESS"
    ],
    "availableCars": 997,
    "pointOfInterest": false
  },
  {
    "address": {
      "position": {
        "latitude": 59.33126,
        "longitude": 17.95671
      },
      "zone": 312,
      "streetName": "Stora Mossens Koloniomr",
      "entrance": "",
      "city": "Stockholm"
    },
    "locationTypes": [
      "POINT_OF_INTEREST"
    ],
    "availableCars": 997,
    "pointOfInterest": true
  },
  {
    "address": {
      "position": {
        "latitude": 59.321648,
        "longitude": 18.155075
      },
      "zone": 163,
      "streetName": "Blockhusringen",
      "streetNumber": "27",
      "entrance": "",
      "city": "Stockholm"
    },
    "locationTypes": [
      "ADDRESS"
    ],
    "availableCars": 997,
    "pointOfInterest": false
  },
  {
    "address": {
      "position": {
        "latitude": 59.37133,
        "longitude": 18.04913
      },
      "zone": 149,
      "streetName": "Veit Wittrocks Väg",
      "streetNumber": "2",
      "entrance": "",
      "city": "Stockholm"
    },
    "locationTypes": [
      "ADDRESS"
    ],
    "availableCars": 997,
    "pointOfInterest": false
  },
]

const formatAddress = address => {
  return address.streetNumber 
    ? address.streetName + ' ' + address.streetNumber
    : address.streetName
}

const shuffleArray = arr => {
  const newArr = arr.slice()
  for (let i = newArr.length - 1; i > 0; i--) {
    const rand = Math.floor(Math.random() * (i + 1));
    [newArr[i], newArr[rand]] = [newArr[rand], newArr[i]];
  }
  return newArr
}

export const DebugListener = ({ id }) => {
  const { values, errors, setFieldValue } = useFormikContext()
  const { user } = useContext(StoreContext)
  const index = useRef(0)

  const appendLocation = () => {
    const location = locations[index.current++]
    console.log(formatAddress(location.address))

    if (values.departure?.address === undefined) {
      setFieldValue('departure', location)
    }
    else if (values.destination?.address === undefined) {
      setFieldValue('destination', location)
    }
    else {
      const stops = [...values.intermediateStopLocations, values.destination]
      setFieldValue('destination', location)
      setFieldValue('intermediateStopLocations', stops)
    }

    if (index.current === locations.length) {
      index.current = 0
    }
  }

  const shuffleStops = () => {
    const items = shuffleArray([values.departure, ...values.intermediateStopLocations, values.destination])

    setFieldValue('departure', items[0])
    setFieldValue('destination', items[items.length - 1])

    if (items.length > 2) {
      const stops = items.slice(1, -1)
      setFieldValue('intermediateStopLocations', stops)
    }
    else {
      setFieldValue('intermediateStopLocations', [])
    }
  }

  const prepareBookingAndPay = () => {
    prepareBooking(values, user.userId).then((response) => {
      console.log(response)
      if (response?.bookingId) {
        // emitCustomEvent('CASHIER_PAY_BOOKING', { bookingId: response.bookingId })
        getPaymentToken(user.userId, response.bookingId).then((paymentToken) => {
          console.log(paymentToken)
          processPayment(user.userId, values.account.accountId, paymentToken).then((response) => {
            console.log(response)
            if (response.success) {
              // Show IFRAME with provider redirect
              if (response.redirectOutput) {
                console.log('Success, redirect to provider.')
                emitCustomEvent('SHOW_IFRAME', response.redirectOutput)
              }
              // No redirect needed, close overlay
              else {
                console.log('Success, no redirect needed.')
              }
            }
            // No success, show error message
            else {
              let message = response.errors.map(item => item.msg).join('. ')
              if (!/\.$/.test(message)) {
                message += '.'
              }
              APP.trigger(
                APP.events.SHOW_MODAL,
                message, [
                  { title: COPY.booking.button_ok },
                ]
              )
            }
          })
          .catch((error) => {
            console.error(error)
          })
        })
        .catch((error) => {
          console.error(error)
        })
      }
      else {
        console.error('No bookingId!')
      }
    })
    .catch((error) => {
      console.error(error)
    })
  }

  useCustomEventListener('APPEND_LOCATION', appendLocation, [values, setFieldValue])
  useCustomEventListener('SHUFFLE_STOPS', shuffleStops, [values, setFieldValue])
  useCustomEventListener('PREPARE_BOOKING', prepareBookingAndPay)

  useCustomEventListener(
    'LOG_VALUES',
    (targetId) => {
      if (id === targetId) {
        console.log(values)
        console.log(errors)
      }
    },
    [values]
  )

  return null
}

export default function DebugPanel() {
  const { user, bookings } = useContext(StoreContext)

  return (
    <div className={classnames(styles.wrapper, styles.container)}>
      <span className={styles.title}>Debug:</span>
      <button onClick={() => console.log(user)}>User</button>
      <button onClick={() => console.log(bookings)}>Bookings</button>
      <span>|</span>
      <button onClick={() => emitCustomEvent('LOG_VALUES', 'main')}>Booking values</button>
      <button onClick={() => emitCustomEvent('LOG_VALUES', 'package')}>Package values</button>
      <button onClick={() => emitCustomEvent('LOG_VALUES', 'otp')}>OTP values</button>
      <div className={classnames(styles.container, styles.mapButtons)}>
        <span>|</span>
        <button onClick={() => emitCustomEvent('APPEND_LOCATION')}>Append location</button>
        <button onClick={() => emitCustomEvent('SHUFFLE_STOPS')}>Shuffle stops</button>
        <button onClick={() => emitCustomEvent('DISPLAY_TRIP')}>Display trip</button>
        <button onClick={() => emitCustomEvent('RESET_MAP')}>Reset map</button>
      </div>
      <span>|</span>
      <button onClick={() => emitCustomEvent('CASHIER_ADD_CARD', { success: () => console.log('Success') })}>Add card</button>
      <button onClick={() => emitCustomEvent('PREPARE_BOOKING')}>Prepare booking</button>
    </div>
  )
}
